import Bluebird from 'bluebird';
import ajax from './ajax';

let cached: string;

export default function getCountry(): Bluebird<string | null> {
    if (cached) return Bluebird.resolve(cached);

    return ajax<ToolAPI.CountryResponse>('GET', '/api/country')
        .then(response => {
            const { country } = response;
            if (country) cached = country;
            return country;
        });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/geolocate.ts